import { AxiosInstance } from 'axios';
import { TApiResponse } from '@type/common';
import {
  TBatchRepurchaseOverduePaymentsResponse,
  TGetOverduePaymentOrdersParams,
  TGetOverduePaymentOrdersResponse,
} from './type';

export default (axios: AxiosInstance, apiPrefix: string) => ({
  /** 取得金流逾期列表 */
  getOverduePaymentOrders({
    paymentType,
    ...params
  }: TGetOverduePaymentOrdersParams): TApiResponse<TGetOverduePaymentOrdersResponse> {
    return axios.get(
      `${apiPrefix}/intermediate-payment/${paymentType}/overdue`,
      { params },
    );
  },
  /** 回購金流款項 */
  repurchaseOverduePayment(
    orderId: string,
  ): TApiResponse<{ success: boolean }> {
    return axios.post(
      `${apiPrefix}/intermediate-payment/${orderId}/repurchase`,
    );
  },
  /** 多筆回購金流款項 */
  batchRepurchaseOverduePayments(payload: {
    orderIds: string[];
  }): TApiResponse<TBatchRepurchaseOverduePaymentsResponse> {
    return axios.post(`${apiPrefix}/intermediate-payment/repurchases`, payload);
  },
});
